import React, { useState } from "react";
import Drawer from "react-drag-drawer";
import FormCallUs from "./faleconosco-form/index";
import { playSong } from "../../utils/song";
import songsName from "../../enums/songsName";
import { FiX } from "react-icons/fi";
import { BsArrowLeftCircle } from 'react-icons/bs';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'

const CallUsModal = ({
  show_callus,
  toggle_callus,
  appState,
  backToDrawerMenu
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const closeHandler = () => {
      playSong(songsName.TAP)
      toggle_callus()
    }

  return (
    <Drawer
      dontApplyListeners={true}
      allowClose={false}
      open={show_callus}
      onRequestClose={() => toggle_callus(false)}
      direction="left"
      modalElementClass="absolute top-0 left-0"
    >
      <div
        className={`w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 pb-4 text-lg overflow-y-auto`}
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='w-full flex flex-row justify-between items-center'>
          <div className='w-full flex flex-row justify-between items-center'>
            <div
              className='flex flex-row justify-start items-center cursor-pointer'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                backToDrawerMenu()
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-blue-primary" />
            </div>

            <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
            >
              <FiX className="w-8 h-8 text-blue-primary" />
            </button>
          </div>
        </div>

        <h2 className='text-blue-primary font-bold text-xl text-center mx-auto my-8'>Fale conosco</h2>

        <p className="text-lg">
          Ficou com alguma dúvida ou quer dar sua opinião? Então banque o autor e escreva para nós!
        </p>
        
        <FormCallUs
          toggle_callus={toggle_callus}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isSuccess={isSuccess}
          setIsSuccess={setIsSuccess}
          appState={appState}
        />
        <p className="text-sm mt-4">
          A gente vai responder o mais rápido que puder.
        </p>
      </div>

      {/* <div className="modal modal-callus">
        <div className="modal-container-callus">
          <h2 style={{ padding: 10, marginBlockEnd: 0 }}>FALE CONOSCO</h2>
          <p style={{ padding: 10, margin: 0 }}>
            Ficou com alguma dúvida ou quer dar sua opinião? Então banque o autor e escreva para nós!
          </p>
          <FormCallUs
            toggle_callus={toggle_callus}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
            appState={appState}
          />
          <p style={{ padding: 10 }}>
            A gente vai responder o mais rápido que puder.
          </p>
        </div>
      </div> */}
    </Drawer>
  );
};
export default CallUsModal;